import { Dispatch } from 'redux'
import {
  ErrorNotification,
  SuccessNotification,
} from 'app/views/components/notifications/notification'
import {
  placeFacilityHold,
  liftFacilityHold,
} from 'app/state/ducks/facilities/thunks'
import { HoldPayload } from 'app/views/components/holds/hold-form-utils'

export const placeFacilityHoldAction = async (
  facilityId: string,
  payload: HoldPayload,
  dispatch: Dispatch<any>,
): Promise<boolean> => {
  const result: any = await dispatch(
    placeFacilityHold({ facilityId, ...payload }),
  )
  if (!result.success) {
    ErrorNotification({ title: 'Place Lock Failed', message: result.payload })
    return false
  }
  SuccessNotification({
    title: 'Lock Placed',
    message: 'The facility has been locked.',
  })
  return true
}

export const liftFacilityHoldAction = async (
  facilityId: string,
  liftReason: string | undefined,
  dispatch: Dispatch<any>,
): Promise<boolean> => {
  const result: any = await dispatch(
    liftFacilityHold({ facilityId, ...(liftReason ? { liftReason } : {}) }),
  )
  if (!result.success) {
    ErrorNotification({ title: 'Lift Lock Failed', message: result.payload })
    return false
  }
  SuccessNotification({
    title: 'Lock Lifted',
    message: 'The facility lock has been lifted.',
  })
  return true
}
